module.exports = __webpack_public_path__ + "img/bosfor-price_bg.9cf7ca89.svg";